<app-main-resource-catalog [scope]="AppScope.SURVEY"></app-main-resource-catalog>
